import { useState, useEffect, Fragment } from 'react'
import NumberInput from 'components/Inputs/NumberInput'
import Select from 'components/Inputs/Select'
import ProfessionalServicesModal from 'pages/Modals/ServicesModal/Professional'
import ImportServicesModal from 'pages/Modals/ImportServicesModal'
import CheckBox from 'components/CheckBox'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import AlertDialog from 'components/AlertDialog'
import Logo from 'icons/logo-cutilei-simple.png'
import { FaFileImport, FaTrash, FaPlus } from 'react-icons/fa'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Grid,
  Row,
  CheckRow,
  InnerContainer,
  Image,
  SubTitle,
  MoneyTextMask,
  Label,
  GridLabel,
  DangerButton
} from '../styles'

export default function ServicesForm ({
  professionalData = {},
  serviceCategories = [],
  cutileiServices = [],
  professionals = [],
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [serviceToRemove, setServiceToRemove] = useState (null)
  const [categoryToRemove, setCategoryToRemove] = useState (null)
  const [showServicesModal, setShowServicesModal] = useState (false)
  const [showImportServicesModal, setShowImportServicesModal] = useState (false)
  const [showErrorDialog, setShowErrorDialog] = useState (false)

  const toggleImportServicesModal = () => setShowImportServicesModal (!showImportServicesModal)
  const toggleServicesModal = () => setShowServicesModal (!showServicesModal)
  const toggleErrorDialog = () => setShowErrorDialog (!showErrorDialog)

  return (
    <Formik
      initialValues={{
        'accepts_cutilei': professionalData.accepts_cutilei,
        'service_categories': professionalData.service_categories,
        'services': professionalData.services
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {function ProfessionalServicesForm ({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleSubmit
      }) {
        useEffect (() => {
          if (!values.service_categories.some (c => c.name.toLowerCase () === 'manicure e pedicure')) {
            setFieldValue ('services', values.services.filter (service => (
              !cutileiServices.some (s => s.category.id === service.category.id)
            )))
          } else {
            addCutileiServices ()
          }
        }, [values.service_categories])

        const handleCategoriesAdded = (name, categories) => {
          setFieldValue (name, categories.map (c => c.value))
        }

        const removeServiceCategory = category => {
          setFieldValue ('service_categories', values.service_categories.filter (c => c.id !== category.id))
        }

        const addCutileiServices = () => {
          if (values.services.some (s => s.cutilei_service === true))
            return

          setFieldValue ('services', [
            ...cutileiServices.map (service => ({
              ...service, comission_percentage: service.comission_percentage * 100,
            })),
            ...values.services
          ])
        }

        const handleAcceptsCutileiChange = value => {
          const isNailsCategory = c => c.name.toLowerCase () === 'manicure e pedicure'
          const nailsCategory = serviceCategories.find (isNailsCategory)
          const hasNailsCategory = values.service_categories.some (isNailsCategory)

          setFieldValue ('accepts_cutilei', value)

          if (value === true) {
            if (nailsCategory && !hasNailsCategory) {
              setFieldValue ('service_categories', [...values.service_categories, nailsCategory])
            }
            addCutileiServices ()
          }
          
          if (value === false) {
            const filteredServices = values.services.filter (s => !s.cutilei_service)
            
            setFieldValue ('services', filteredServices)

            if (!filteredServices.some (s => s.category.name.toLowerCase () === 'manicure e pedicure')) {
              setFieldValue ('service_categories', values.service_categories.filter (c => (
                c.name.toLowerCase () !== 'manicure e pedicure')
              ))
            }
          }
        }

        const handleServicesAdded = (addedServices, serviceCategories) => {
          const uniqueCategories = new Set (values.service_categories.map (c => JSON.stringify (c)))

          serviceCategories.forEach (c => uniqueCategories.add (JSON.stringify (c)))
          const updatedCategories = Array.from (uniqueCategories).map (c => JSON.parse (c))

          setFieldValue ('services', [
            ...values.services,
            ...addedServices.map (s => ({
              ...s, comission_percentage: s.comission_percentage * 100
            }))
          ])
          setFieldValue ('service_categories', updatedCategories)
        }

        const handleServiceDeleted = deletedService => {
          const updatedServices = values.services.filter (s => s.id !== deletedService.id)
          const serviceCategory = deletedService.category

          setFieldValue ('services', updatedServices)

          if (!updatedServices.some (s => s.category.id === serviceCategory.id)) {
            removeServiceCategory (serviceCategory)
          }
        }

        return (
          <Form onKeyDown={submitOnEnter(handleSubmit)}>
            <SubTitle>Serviços e cadastro de comissões do profissional</SubTitle>
            <InnerContainer>
              <SubTitle>Este(a) profissional atenderá a Cutilei?</SubTitle>
              <Row style={{gap: 20, marginBottom: 0}}>
                <CheckRow>
                  <CheckBox
                    id='accepts_cutilei'
                    value={values.accepts_cutilei}
                    onValueChange={() => handleAcceptsCutileiChange (true)}
                  />
                  <Label htmlFor='accepts_cutilei'>Sim</Label>
                </CheckRow>
                <CheckRow>
                  <CheckBox
                    id='!accepts_cutilei'
                    value={!values.accepts_cutilei}
                    onValueChange={() => handleAcceptsCutileiChange (false)}
                  />
                  <Label htmlFor='!accepts_cutilei'>Não</Label>
                </CheckRow>
              </Row>
            </InnerContainer>
            <Row style={{marginBottom: 10}}>
              <Select
                name='service_categories'
                placeholder='Categorias de serviço...'
                value={values.service_categories.map (c => ({label: c.name, value: c}))}
                options={serviceCategories
                  .filter (c => !values.service_categories.some (selected => selected.id === c.id))
                  .map (c => ({ label: c.name, value: c }))
                }
                isMulti={true}
                onChange={handleCategoriesAdded}
                onBlur={setFieldTouched}
                onRemoveOption={option => {
                  if (values.services.some (s => s.category.id === option.value.id && !s.cutilei_service)) {
                    toggleErrorDialog ()
                  } else {
                    setCategoryToRemove (option.value)
                  }
                }}
                error={errors.service_categories}
                touched={touched.service_categories}
                containerStyles={{width: 500}}
              />
            </Row>
            <Row>
              {professionals.length > 0 && (
                <SecondaryButton
                  label='Importar configurações'
                  leftIcon={<FaFileImport size={12} color='#FFC100' style={{marginBottom: 1}}/>}
                  onClick={toggleImportServicesModal}
                  color='#606060'
                  width={200}
                />
              )}
              <SecondaryButton
                label='Adicionar serviços'
                leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 1}}/>}
                onClick={toggleServicesModal}
                color='#606060'
                width={200}
              />
            </Row>
            {values.service_categories.length > 0 && values.services.length > 0 && (
              <>
                <SubTitle>Serviços adicionados</SubTitle>
                <Grid numRows={values.services.length} numColumns={3}>
                  <GridLabel>Serviço</GridLabel>
                  <GridLabel>Duração (mins)</GridLabel>
                  <GridLabel>Tolerância (mins)</GridLabel>
                  <GridLabel>Comissão (%)</GridLabel>
                  <GridLabel style={{fontWeight: 'bold'}}>Valor:</GridLabel>
                  {values.services.map ((service, index) => (
                    <Fragment key={index}>
                      <Label style={{lineHeight: '15px'}}>
                        {service.cutilei_service && <Image src={Logo}/>}
                        {service.nickname || service.name}
                      </Label>
                      <NumberInput
                        name={`services[${index}].duration`}
                        value={values.services[index].duration}
                        minValue={10}
                        onChange={setFieldValue}
                      />
                      <NumberInput
                        name={`services[${index}].max_delay`}
                        value={values.services[index].max_delay}
                        minValue={values.cutilei_service ? (service.name.toLowerCase () === 'pé e mão' ? 10 : 7) : 5}
                        maxValue={values.cutilei_service ? 15 : 20}
                        onChange={setFieldValue}
                      />
                      <NumberInput
                        name={`services[${index}].comission_percentage`}
                        value={values.services[index].comission_percentage}
                        minValue={values.services[index].cutilei_service ? 40 : 0}
                        maxValue={100}
                        onChange={setFieldValue}
                      />
                      <Row style={{marginBottom: 0, alignItems: 'center'}}>
                        <MoneyTextMask
                          value={(values.services[index].comission_percentage / 100 * service.price)}
                          style={{textAlign: 'center'}}
                        />
                        {!service.cutilei_service && (
                          <DangerButton type='button' onClick={() => setServiceToRemove (service)}>
                            <FaTrash/>
                          </DangerButton>
                        )}
                      </Row>
                    </Fragment>
                  ))}
                </Grid>
              </>
            )}
            <ImportServicesModal
              visible={showImportServicesModal}
              professionals={professionals}
              onConfirm={(services, serviceCategories) => {
                setFieldValue ('services', services.map (service => ({
                  ...service, comission_percentage: service.comission_percentage * 100
                })))

                setFieldValue ('service_categories', serviceCategories)
              }}
              onClose={toggleImportServicesModal}
            />
            <ProfessionalServicesModal
              visible={showServicesModal}
              serviceCategories={serviceCategories}
              professionalCategories={values.service_categories}
              onConfirm={handleServicesAdded}
              onClose={toggleServicesModal}
            />
            <AlertDialog
              visible={!!serviceToRemove}
              title='Atenção!'
              message='Deseja realmente excluir este serviço?'
              confirmText='Sim'
              cancelText='Não'
              onConfirm={() => handleServiceDeleted (serviceToRemove)}
              onClose={() => setServiceToRemove (null)}
              dangerous
            />
            <AlertDialog
              visible={!!categoryToRemove}
              title='Atenção!'
              message='Deseja realmente remover esta categoria deste profissional?'
              confirmText='Sim'
              cancelText='Não'
              onConfirm={() => removeServiceCategory (categoryToRemove)}
              onClose={() => setCategoryToRemove (null)}
              dangerous={true}
            />
            <AlertDialog
              visible={showErrorDialog}
              title='Atenção!'
              message='Para remover esta categoria, remova do profissional os serviços dela primeiro'
              confirmText='Ok'
              onConfirm={toggleErrorDialog}
              onClose={toggleErrorDialog}
            />
            <MainButton
              leftIcon={<MdNavigateNext size={30}/>}
              aria-label='Próximo'
              onClick={handleSubmit}
              width={60}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
